import { useFormikContext } from "formik";
import React from "react";

import { ISelfOccupiedProperties } from "../../../../config/interfaces";
import { FormField, NumericInputField } from "../../../fields";

type Props = {};

const RISelfNetTaxableIncomeForm: React.FC<Props> = (props: Props) => {
	const { values, errors, touched, setFieldValue, handleBlur } =
		useFormikContext<ISelfOccupiedProperties>();

	return (
		<>
			<section className="mb-5">
				<FormField
					label={
						<>
							Net Taxable Income
							<small>
								It is the difference between Net income (as per your share) & Deduction (as per your
								share)
							</small>
						</>
					}
					sm={6}
				>
					<NumericInputField
						showLeftIcon={true}
						name="NetTaxableIncome"
						value={values.NetTaxableIncome}
						onBlur={handleBlur("NetTaxableIncome")}
						onChange={(value) => setFieldValue("NetTaxableIncome", Number(value) * -1)}
						isInvalid={Boolean(errors.NetTaxableIncome) && touched.NetTaxableIncome}
						errorMsg={errors.NetTaxableIncome}
						isDisabled={true}
					/>
				</FormField>
			</section>
		</>
	);
};

export default RISelfNetTaxableIncomeForm;
